import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { WeGoConfig, WeGoAuthorizedLink, Permission, PermissionType, DataListModel, ApplicationRouteURL } from "./../../shared/config";
import { TermsConditionModel } from "../models/terms-condition.model";
import { TermsAndConditionsService } from "../models/terms-conditions.service";
import { RoleLevel } from "../../shared/config";
import { SearchFilterModel } from "../models/search-filter.model";
import { TranslateService } from "./../../shared/translate/translate.service";

@Component({
  selector: "Wego-terms-condition-list",
  template: require('../views/terms-condition-list.component.html'),
  providers: [TermsAndConditionsService],
})

export class TermsAndConditionComponent implements OnInit {
  addTermsAndConditionLink: WeGoAuthorizedLink;
  urlTermsAndConditionAdd: string;
  urlTermsAndConditionUpdate: string;
  termsConditionList: TermsConditionModel[];
  isParentCheck: boolean;
  DataListModel: DataListModel;
  urlDefaultPage: string;
  isLoading: boolean = false;
  apiErrorMsg: string;
  roleLevel = RoleLevel;
  model: TermsConditionModel;
  private popupMsg: string;
  private module: string;
  isMultipleDelete: boolean;
  deleteTermsAndConditionsHashId: string;
  errorMessage: string;
  private IsResetParameter: boolean;

  @ViewChild("childModal") public childModal: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("searchForm") public searchForm: any;

  constructor(
    private authService: AuthService,
    private termsAndConditionsService: TermsAndConditionsService,
    private translate: TranslateService
  ) { }

  get isAnyChecked(): boolean {
    if (this.termsConditionList) {
      let isCheck = this.termsConditionList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.termsConditionList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isAnyDeletable(): boolean {
    if (this.termsConditionList) {
      return this.termsConditionList.some(x => (x.termsAndConditionsHashId ? true : false) == true);
    }
    return false;
  }

  get isDeleteAccess(): boolean {
    if (this.termsConditionList) {
      return this.termsConditionList.some(x => x.isDeletable);
    }
    else {
      return false;
    }
  }

  // get isResetParameters(): boolean {
  //   return this.isResetFlag;
  // }

  ngOnInit() {
    this.model = new TermsConditionModel();
    this.DataListModel = new DataListModel();
    this.module = this.translate.instant("LblTermsConditionPrivacy");

    this.urlTermsAndConditionAdd = this.authService.GetURL(ApplicationRouteURL.URL_TERMS_AND_CONDITION_ADD);
    this.urlTermsAndConditionUpdate = this.authService.GetURL(ApplicationRouteURL.URL_TERMS_AND_CONDITION_UPDATE);
    this.addTermsAndConditionLink = new WeGoAuthorizedLink(
      this.urlTermsAndConditionAdd,
      Permission.PR_TERMS_AND_CONDITION,
      PermissionType.INSERT,
      "btn btn-highlight navbar-right",
      "LblAddNew",
    );

    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.model = this.authService.AssignFromStorage(
      this.constructor.name + "_model",
      this.model
    );

    this.DataListModel.searchField = ["name", "type",'version'];

    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
      this.DataListModel.searchField.push("instanceName");
    }
    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Company) {
      this.DataListModel.searchField.push("companyName");
    }
    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Organization) {
      this.DataListModel.searchField.push("organizationName");
    }
    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.SVG) {
      this.DataListModel.searchField.push("sharedVehicleGroupName");
      this.DataListModel.searchField.push("subscriptionName");
    }


    this.GetTermsAndConditionsList();
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
  }
  private OnPageChanged(event: any): void {
    this.isLoading = true;
    this.DataListModel.currentPage = event.page;
    this.GetTermsAndConditionsList();
  };

  public OnSearch(event: any) {
    if (event.isReset == false) {
      this.DataListModel = this.authService.GetSearchParameters(
        this.DataListModel,
        event.searchTerm,
        event.isReset
      );
      this.IsResetParameter = false;
      this.GetTermsAndConditionsList();
    }
    else {
      this.OnAdvanceReset(event);
    }
  }

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetTermsAndConditionsList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.termsConditionList.filter(x => x.isDeletable).forEach(x => x.isChecked = (isChecked && x.termsAndConditionsHashId ? true : false));
  }

  OnDetailSearch($event: any) {
    if ($event.InstanceHashIdList) {
      this.model.instanceHashIdList = $event.InstanceHashIdList;
    }
    if ($event.CompanyHashIdList) {
      this.model.companyHashIdList = $event.CompanyHashIdList;
    }
    if ($event.OrganizationHashIdList) {
      this.model.organizationHashIdList = $event.OrganizationHashIdList;
    }
    if ($event.SharedVehicleGroupHashIdList) {
      this.model.sharedVehicleGroupHashIdList = $event.SharedVehicleGroupHashIdList;
    }
  }

  public GetTermsAndConditionsList() {
    this.isLoading = true;

    this.termsAndConditionsService.GetTermsAndConditionList(this.model, this.DataListModel)
      .subscribe(
        res => {
          this.termsConditionList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.termsConditionList = [];
        });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.termsAndConditionsService
      .ExportTermsAndConditionList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "TermsAndConditions" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ShowChildModal(termsAndConditionsHashId?: string): void {
    if (termsAndConditionsHashId) {
      this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
        this.module
      ]);
      this.isMultipleDelete = false;
      this.deleteTermsAndConditionsHashId = termsAndConditionsHashId;
    } else {
      this.popupMsg = this.translate.instant(
        "LblRecordMultiplDeleteConfirmation",
        [this.module]
      );
      this.isMultipleDelete = true;
    }
    this.childModal.show();
  }

  public SuccessModalClick(): void {
    let deletedTermsAndConditionsList: any[];
    if (this.isMultipleDelete)
      deletedTermsAndConditionsList = this.termsConditionList
        .filter(x => x.isChecked)
        .map(x => x.termsAndConditionsHashId);
    else deletedTermsAndConditionsList.push(this.deleteTermsAndConditionsHashId);

    this.DeleteTermsAndConditions(deletedTermsAndConditionsList);
    this.childModal.hide();
  }

  public HideChildModal(): void {
    this.deleteTermsAndConditionsHashId = "";
    this.childModal.hide();
  }

  public DeleteTermsAndConditions(deletedTermsAndConditionsList: string[]) {
    this.isLoading = true;
    this.termsAndConditionsService.DeleteTermsAndConditions(deletedTermsAndConditionsList).subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetTermsAndConditionsList();
        this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
          this.module
        ]);
        this.ShowSuccessPopup();
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public OnAdvanceReset(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      "",
      event.isReset
    );
    this.IsResetParameter = true;

    this.model.instanceHashIdList = [];
    this.model.instanceHashId = '';
    this.model.companyHashId = '';
    this.model.companyHashIdList = [];
    this.model.organizationHashId = '';
    this.model.organizationHashIdList = [];
    this.model.sharedVehicleGroupHashId = '';
    this.model.sharedVehicleGroupHashIdList = [];


    this.GetTermsAndConditionsList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetTermsAndConditionsList();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
    this.authService.SaveToStorage(
      this.constructor.name + "_model",
      this.model
    );
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/components/terms-condition-list.component.ts